(function($) {
  var selector = document.querySelectorAll('.lazy')
  Array.prototype.forEach.call(selector, el => {
    var src = el.getAttribute('data-src') || null
    if (src) {
      inViewport(el, () => {
        el.setAttribute('src', src)
      })
    }
  })
})(jQuery);